export default {
    getPlace: state => (placeId) => state.places.find((place) => place.id == placeId),
    getTypeName: state => (place) => state.placeTypes.find((pT) => pT.type === place.type).name
}
